import { PatientInfoValues } from '../enums/patient-info-values.enum';

export const PatientInfoValueIcon = {
  [PatientInfoValues.SPECIES]: 'pets',
  [PatientInfoValues.BREED]: 'category', // 'mediation'
  [PatientInfoValues.WEIGHT]: 'weight',
  [PatientInfoValues.BIRTH_DATE]: 'cake',
  [PatientInfoValues.GENDER]: 'female',
  [PatientInfoValues.OWNER_NAME]: 'person_pin',
  [PatientInfoValues.OWNER_EMAIL]: 'email',
  [PatientInfoValues.OWNER_PHONE_NUMBER]: 'phone'
};
